import FormLabel from './FormLabel'

export default FormLabel



// WEBPACK FOOTER //
// ./src/components/Form/Label/index.js